import React from 'react';
import { StarIcon } from 'lucide-react';

interface StarRatingProps {
    rating: number;
    size?: 'sm' | 'md' | 'lg';
    className?: string;
}

const StarRating: React.FC<StarRatingProps> = ({
    rating,
    size = 'md',
    className = ''
}) => {
    const displayRating = rating;
    const sizeClasses = {
        sm: {
            container: 'size-5',
            icon: 'w-3 h-3'
        },
        md: {
            container: 'size-6',
            icon: 'w-4 h-4'
        },
        lg: {
            container: 'size-8',
            icon: 'w-6 h-6'
        }
    };

    const renderStars = () => {
        const stars = [];
        const totalStars = 5;

        for (let i = 1; i <= totalStars; i++) {
            const starFill = Math.min(1, Math.max(0, displayRating - (i - 1)));
            const fillPercent = Math.round(starFill * 100);
            const fillRoundedClass = fillPercent === 100 ? '' : '';

            stars.push(
                <div
                    key={i}
                    className={`${sizeClasses[size].container} relative overflow-hidden rounded-md bg-gray-300`}
                >
                    {fillPercent > 0 && (
                        <div
                            className={`absolute inset-y-0 left-0 bg-green ${fillRoundedClass}`}
                            style={{ width: `${fillPercent}%` }}
                        />
                    )}
                    <StarIcon
                        className={`${sizeClasses[size].icon} text-white absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2`}
                        fill="white"
                        stroke="white"
                    />
                </div>
            );
        }
        return stars;
    };

    return (
        <div className={`flex flex-row gap-1 ${className}`}>
            {renderStars()}
        </div>
    );
};

export default StarRating; 
